"use client";
import Image from "next/image";
import GoogleStars from "./GoogleStars";

function ReviewCard({ rev, i, card, aktual, isActive }) {
  const { author, content, authorPhotoUrl, rating } = rev;

  // console.log(card);
  return (
    <div
      key={i}
      ref={card}
      className={`review-card review-card-${i} flex flex-col ${isActive ? "opacity-100" : "opacity-20"} my-8 w-[19rem] items-center justify-center gap-5 rounded-2xl bg-gray-50 px-5 py-4 transition-opacity duration-1000 first:ml-10 md:my-10 md:h-72 md:w-[55rem] md:flex-row md:items-start md:gap-14 md:py-10 md:pl-10 md:pr-12 md:first:ml-72`}
    >
      <div className="relative h-[96px] w-[96px] md:h-40 md:w-40">
        <Image
          fill
          sizes="(max-width: 750px) 10vw, 172px"
          alt="photo-recenzent"
          className="rounded-full object-cover"
          src={authorPhotoUrl}
        />
      </div>
      <div className="inline-flex min-w-64 flex-col items-center justify-start gap-5 md:w-64 md:min-w-[550px] md:items-start md:gap-6">
        <p className="order-3 h-32 overflow-y-auto pt-0 text-center text-base font-normal text-neutral-700 md:h-[9.25rem] md:text-justify md:text-2xl">
          {content}
        </p>
        <div className="order-1 flex flex-col items-center justify-start md:order-last md:items-start">
          <div className="font-raleway text-2xl font-bold tracking-wide text-black">
            {author}
          </div>
          <div className="font-roboto text-base font-normal leading-normal text-teal">
            <GoogleStars rating={rating} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReviewCard;
